"use client";

import { useState } from "react";
import ClassCalendar from "./ClassCalendar";

export default function ScheduleSectionWithTabs({
  scheduleImageUrl = null,
  scheduleImageAlt = "Gym Class Schedule",
}) {
  const hasScheduleImage = Boolean(scheduleImageUrl?.trim());
  const [activeTab, setActiveTab] = useState(hasScheduleImage ? "schedule" : "book");
  const [imageError, setImageError] = useState(false);
  const showImageTab = hasScheduleImage && !imageError;

  return (
    <div className="w-full max-w-6xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Class Schedule
        </h2>
        {showImageTab && (
          <div className="inline-flex rounded-lg border border-[#D4AF37] bg-[#FFF8E7] p-1">
            <button
              type="button"
              onClick={() => setActiveTab("schedule")}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                activeTab === "schedule"
                  ? "bg-[#D4AF37] text-black shadow"
                  : "text-gray-700 hover:text-gray-900"
              }`}
            >
              Schedule
            </button>
            <button
              type="button"
              onClick={() => setActiveTab("book")}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                activeTab === "book"
                  ? "bg-[#D4AF37] text-black shadow"
                  : "text-gray-700 hover:text-gray-900"
              }`}
            >
              Book classes
            </button>
          </div>
        )}
      </div>

      <div className="bg-[#FFF8E7] rounded-lg shadow-lg border border-[#D4AF37] p-4 md:p-6">
        {showImageTab && activeTab === "schedule" && (
          <img
            src={scheduleImageUrl.trim()}
            alt={scheduleImageAlt}
            className="w-full h-auto rounded-lg"
            onError={() => {
              setImageError(true);
              setActiveTab("book");
            }}
          />
        )}
        {(!showImageTab || activeTab === "book") && <ClassCalendar />}
      </div>
    </div>
  );
}
